<template>
  <div class="report-metric-card">
    <div class="report-metric-card__value">
      {{ value }}{{ suffix }}
    </div>
    <div
      v-if="label"
      class="report-metric-card__label"
    >
      {{ label }}
    </div>
    <div
      v-if="$slots.sub || subText"
      class="report-metric-card__sub"
    >
      <slot name="sub">
        {{ subText }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportMetricCalloutCard',
  props: {
    value: {
      type: [ String, Number ],
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.report-metric-card {
  background-color: #0b2823;
  padding: 18px 15px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  min-height: 118px;
  font-family: Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
}

.report-metric-card__value {
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-size: clamp(20px, 3vw, 32px);
  font-weight: 600;
  color: white;
  line-height: 1.1;
}

.report-metric-card__label {
  font-family: Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-size: clamp(10px, 3vw, 16px);
  font-weight: 400;
  color: white;
  opacity: 0.85;
}

.report-metric-card__sub {
  font-family: Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-size: clamp(10px, 3vw, 16px);
  font-weight: 400;
  opacity: 0.85;
  color: white;
}

.report-metric-card__sub :deep(b),
.report-metric-card__sub :deep(strong) {
  font-family: Roobert-Semi-Bold, Roobert, 'Segoe UI', Arial, sans-serif !important;
  font-weight: 600 !important;
}
</style>
